export default function Footer() {
  return (
    <footer className="bg-[#0F1B2E] text-white py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-16">
        {/* Top Section */}
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-black mb-6 text-[#D4AF37] font-serif">万燈</h3>
          <p className="text-lg text-[#E8D7C3] leading-relaxed font-serif">
            低与信者市場に特化した<br />
            革新的な車両リース<br />
            プラットフォーム
          </p>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 pt-12">
          {/* Seminar Schedule */}
          <div className="text-center mb-12">
            <h4 className="text-xl font-bold mb-6 text-[#D4AF37] font-serif">セミナー日程</h4>
            <div className="space-y-3 text-gray-300 font-serif">
              <p className="line-through">1月29日20時～（締め切り16時）</p>
              <p>1月30日20時～（締め切り16時）</p>
              <p className="text-sm mt-4">両日18時zoomリンクをメールで送付する</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
